import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "message"]

  connect() {
    this.timeout = null
  }

  check() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.validate(), 300)
  }

  async validate() {
    const name = this.inputTarget.value.trim()
    if (name === "") {
      this.messageTarget.textContent = ""
      this.messageTarget.classList.add("hidden")
      return
    }

    try {
      const url = this.element.dataset.checkUrl + "?" + new URLSearchParams({ name: name })
      const response = await fetch(url, { headers: { "Accept": "application/json" } })
      const data = await response.json()

      if (data.taken) {
        this.messageTarget.textContent = `"${name}" is already in use. Re-importing will replace existing claims.`
        this.messageTarget.classList.remove("hidden")
      } else {
        this.messageTarget.textContent = ""
        this.messageTarget.classList.add("hidden")
      }
    } catch (e) {
      // Silently ignore network errors
    }
  }
}
